import { render, staticRenderFns } from "./NotasGestion.vue?vue&type=template&id=29569016&"
import script from "./NotasGestion.vue?vue&type=script&lang=js&"
export * from "./NotasGestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports